import Vue from 'vue'

// Helper functions
function prepareFilterObjToApi(filterObj, rootState) {
    return {
        'request.supplierId': rootState.user.account.supplierId,
        'request.dateStart': filterObj.dateRange[0],
        'request.dateEnd': filterObj.dateRange[1],
        'request.documentCode': filterObj.string,
        'request.ProductId': filterObj.productId,
        'request.agentId': filterObj.agentId,
        'request.userAccountId': filterObj.userId,
        'request.channelType': filterObj.channelType,
        'request.invoiceTargetType': filterObj.targetType,
        'request.invoiceType': filterObj.invoiceType,
        page: filterObj.page,
    }
}

const state = {
    filters: {
        dateRange: [],
        string: '',
        productId: null,
        agentId: null,
        userId: null,
        channelType: null,
        targetType: null,
        invoiceType: null,
        page: 1,
    },
    isDownloadingInvoiceList: false,
    invoiceList: [],
    isDownloadingExcel: false,
};

const getters = {
    getInvoicePageData: state => state,
    getInvoiceList: state => state.invoiceList,
    getInvoicePageFilters: state => state.filters,
    getIsDownloadingInvoiceList: state => state.isDownloadingInvoiceList
};

const actions = {
    downloadInvoiceList: ({ state, commit, rootState }, page) => {
        state.isDownloadingInvoiceList = true

        if (page) {
            state.filters.page = page
        } else {
            state.filters.page = 1
        }


        let downloadParams = prepareFilterObjToApi(state.filters, rootState)

        return axios.get('/api/invoice/documents', {
            params: downloadParams
        }).then(response => {
            state.isDownloadingInvoiceList = false
            if (response.status == 200) {
                commit('UPDATE_INVOICE_LIST', response.data)
            }
            return response
        }).catch(err => {
            state.isDownloadingInvoiceList = false
            return err
        })
    },

    clearInvoicePageFilters: ({ commit }) => {
        commit('CLEAR_FILTERS')
    },

    exportInvoicePageExcel: ({ state, rootState, commit }) => {
        state.isDownloadingExcel = true;
        return axios.get('/api/invoice/export', {
            params: prepareFilterObjToApi(state.filters, rootState),
            responseType: 'blob'
        }).then(response => {
            state.isDownloadingExcel = false
            // return response
            if (response.status == 200) {

                window.URL = window.URL || window.webkitURL;
                const headers = response.headers;
                const blob = new Blob([response.data], { type: headers['content-type'] });
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = window.URL.createObjectURL(blob);
                link.download = 'invoices_' + state.filters.dateRange[0] + '_' + state.filters.dateRange[1] + '.xlsx';
                link.click();

            }
        }).catch(err => {
            state.isDownloadingExcel = false
            return err
        })
    }
};

const mutations = {
    UPDATE_INVOICE_LIST: (state, payload) => {
        state.invoiceList = payload
    },

    CLEAR_FILTERS: (state) => {
        state.filters = {
            dateRange: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            string: null,
            productId: null, // int
            agentId: null, // int
            userId: null, // int
            channelType: null,
            page: 1,
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoicesPage.js